import React, { useState, useEffect, useMemo } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useCartStore from '../context/CartStore'; // Asegúrate de usar la ruta correcta

const MobileCartButton = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const cartCount = useCartStore((state) => state.count); // Obtenemos el contador del carrito

  const checkIsMobile = () => {
    const mobileBreakpoint = 768;
    setIsMobile(window.innerWidth <= mobileBreakpoint);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const memoizedIsMobile = useMemo(() => isMobile, [isMobile]);

  const handleRedirectToCart = () => {
    navigate('/cart');
  };

  if (!memoizedIsMobile) {
    return null;
  }

  return (
    <div className="fixed top-20 right-4 z-50">
      <button
        type="button"
        onClick={handleRedirectToCart}
        className="bg-primary text-white p-3 rounded-full shadow-lg hover:bg-primary-dark transition-colors flex items-center justify-center relative"
        aria-label="Ir al carrito"
      >
        <ShoppingCart size={24} />
        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
            {cartCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default React.memo(MobileCartButton);